<!-- PROMO POPUP -->
@if (bannerService.showPopup()) {
    <div class="modal fade" id="promoModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-promo">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ bannerService.titolo() }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" [innerHTML]="testoSafe"></div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
}
<!-- // PROMO POPUP -->

<div class="container-fluid">
    <!-- SLIDE IMMAGINI ANIMATE -->
    <app-slide></app-slide>
    <!--// SLIDE IMMAGINI ANIMATE -->

    <h1 class="text-center">{{ "home.h1" | T }}</h1>

    <!-- EMBLA CAROUSEL PRODOTTI E RICAMBI -->
    @defer (on viewport; hydrate on viewport) {
        <app-embla-carousel></app-embla-carousel>
    } @placeholder {
        <div class="defer-ph" style="min-height: 320px;"></div>
    }
    <!--// EMBLA CAROUSEL -->

    <!--CATEGORIE CAROUSEL -->
    <section appFadeInUp class="categories-section" aria-labelledby="offers-heading">
        <div class="section-title-wrapper">
            <h2 id="offers-heading" class="section-title">{{ "home.offers" | T }}</h2>
        </div>
        <div class="carousel-container" role="region" aria-label="Product categories carousel">
            @defer (on viewport; hydrate on viewport) {
                <app-emp-carousel-categorie></app-emp-carousel-categorie>
            } @placeholder {
                <div class="defer-ph" style="min-height: 340px;"></div>
            }
        </div>
    </section>
    <!--// CATEGORIE CAROUSEL -->

    <!-- BANNER SECTION -->
    <section class="banner-section-wrapper" aria-labelledby="banner-promo-label">
        <div class="banner-bg" style="background-image: url(/images/banners/banner-3a.webp);">
            <div class="banner col-md-11 m-auto">
                <h5 id="banner-promo-label" class="banner-promo-label">{{ 'promo_special'|T }}</h5>
                <h4 class="banner-discount">
                    <sup>{{ 'home.sconti' | T}}</sup>
                    <b class="coupon-sale-text ls-10 text-white align-middle">50%</b>
                </h4>
            </div>
        </div>
    </section>
    <!--// BANNER SECTION -->

    <!-- VETRINA CAROUSEL -->
    <section appFadeInUp  class="prodotti-vetrina-section" aria-labelledby="vetrina-heading">
        <div class="section-title-wrapper">
            <h2 id="vetrina-heading" class="section-title">{{ "home.vetrina" | T }}</h2>
        </div>
        <div class="carousel-container" role="region" aria-label="Prodotti in vetrina">
            @defer (on viewport; hydrate on viewport) {
                <app-emp-carousel-vetrina></app-emp-carousel-vetrina>
            } @placeholder {
                <div class="defer-ph" style="min-height: 340px;"></div>
            }
        </div>
    </section>
    <!--// VETRINA CAROUSEL -->

    <!-- LAST POSTs -->
    @if(show_blog_item) {
        <section appFadeInUp  class="blog-section" aria-labelledby="blog-heading">
            <div class="section-title-wrapper">
                <h2 id="blog-heading" class="section-title">BLOG: <a class="text-reset text-decoration-none" [routerLink]="['/blog']">{{ "blog.last_post" | T }}</a></h2>
            </div>
            <div class="carousel-container" role="region" aria-label="Latest blog posts carousel">
                @defer (on viewport; hydrate on viewport) {
                    <app-emp-carousel-last-posts></app-emp-carousel-last-posts>
                } @placeholder {
                    <div class="defer-ph" style="min-height: 340px;"></div>
                }
            </div>
        </section>
    }
    <!--// LAST POSTs -->

    <!-- CONTACT FORM -->
    <section appFadeInUp class="featured-section" aria-labelledby="featured-heading">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    @defer (on viewport; hydrate on interaction) {
                        <app-contact-form></app-contact-form>
                    } @placeholder {
                        <div class="defer-ph" style="min-height: 420px;"></div>
                    }
                </div>
            </div>
        </div>
    </section>
    <!--// CONTACT FORM -->

    <!-- TESTO SEO HOMEPAGE (solo IT per ora) -->
    @if (isItalian) {
        <section class="home-seo container">
            <!-- Contenuto sempre nel DOM (SSR/SEO); collassato visivamente via CSS -->
            <div
                id="homeSeoContent"
                class="home-seo-content"
                [class.expanded]="seoExpanded()"
            >
                <h2>Automazione per cancelli: come funziona e come scegliere il sistema giusto</h2>
                <p>L'<strong>automazione per cancelli</strong> trasforma un'operazione manuale e ripetitiva in un gesto automatico: avvicinarsi, premere un tasto o lasciare che un sensore faccia il lavoro, e il cancello si apre da solo. Dietro questa semplicità c'è una tecnologia consolidata, sviluppata da brand come <strong>CAME</strong>, <strong>FAAC</strong>, <strong>FADINI</strong> e <strong>BFT</strong> nel corso di decenni, e oggi disponibile in soluzioni adatte a ogni contesto, dal cancello a battente di un'abitazione privata fino allo scorrevole industriale di un capannone.</p>
                <p>La scelta del sistema dipende da più variabili: il tipo di cancello (battente o scorrevole), il peso dell'anta, la frequenza di utilizzo e la disponibilità o meno di corrente in loco. Per chi parte da zero, i <a routerLink="/c/i/automazioni-came/kit-completi-cancelli-a-battente/72">kit di automazione cancelli CAME</a> rappresentano il punto d'ingresso più pratico: includono motoriduttore, centrale di comando, fotocellule di sicurezza e telecomandi, tutto già dimensionato e compatibile, così da ridurre al minimo gli errori in fase di installazione.</p>

                <h2>Perché acquistare kit di automazione per cancelli online da noi</h2>
                <p>Su Emporio Elettrico trovi una selezione ampia e organizzata per brand e tipologia di cancello, con <a routerLink="/c/i/faac/kit-completi-cancelli-a-battente/332">kit completi per cancelli a battente FAAC</a> e <a routerLink="/c/i/automazioni-came/kit-completi-cancelli-scorrevoli/127">kit completi per cancelli scorrevoli CAME</a> già pronti all'ordine, pensati per installatori e privati che vogliono trovare tutto il necessario in un solo posto. Il catalogo copre le gamme principali di CAME, FAAC, FADINI, BFT, NICE e BENINCÀ, con <a routerLink="/c/i/automazioni-came/ricambi/661">ricambi originali CAME</a> e accessori, fotocellule, telecomandi, centrali di comando, disponibili separatamente per chi deve integrare o aggiornare un impianto esistente.</p>
                <p>Ogni scheda prodotto riporta le specifiche tecniche necessarie a valutare la compatibilità, senza dover contattare un rivenditore fisico o aspettare un preventivo. Gli ordini sono spediti tramite corrieri espresso nazionali e internazionali e gestiti in media entro 2-4 giorni lavorativi, con tracciatura diretta disponibile nell'area riservata, e per chi ha fretta è disponibile il servizio Speedy con consegna in 1-2 giorni lavorativi.</p>
            </div>

            <button
                type="button"
                class="btn btn-link home-seo-toggle"
                [attr.aria-expanded]="seoExpanded()"
                aria-controls="homeSeoContent"
                (click)="seoExpanded.set(!seoExpanded())"
            >
                {{ seoExpanded() ? 'Leggi di meno' : 'Leggi di più' }}
            </button>
        </section>
    }
    <!--// TESTO SEO HOMEPAGE -->
</div>
